'use client'

import { usePathname } from 'next/navigation'

import { getIsInCatalog } from '@marketplace-web/catalog/catalog-data'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import SearchBar from '../SearchBar'
import { useHeaderSearchType } from '../../hooks/useHeaderSearchType'

function useIsInCatalog(): boolean {
  const pathname = usePathname()

  return getIsInCatalog(pathname ?? '')
}

const ClientSearchBar = (props: Pick<React.ComponentProps<typeof SearchBar>, 'catalogTree'>) => {
  useTrackAbTest(useAbTest('search_by_image_v3'), true)

  return <SearchBar {...props} isInCatalog={useIsInCatalog()} searchType={useHeaderSearchType()} />
}

export default ClientSearchBar
